import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const UserSectionTitle = styled('h1')`
  ${({ theme }) => theme.typography.heroStrong};
  color: ${({ theme }) => theme.color.white};
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  ${media.mdDown`
    padding-left: ${({ theme }) => theme.x2spacePx}px;
  `}
`;
